import { createSelector } from '@reduxjs/toolkit';

export interface SiteFooter {
  data: {
    hashtag: string;
  };
}

export const selectSiteFooter = createSelector(
  [(state) => state.siteHeader as SiteFooter],
  (data) => data,
);
